module.exports = __webpack_public_path__ + "static/media/date_icon.5fcf52c9.svg";